import React, { useState, useEffect } from "react";
import { Message, Button, Icon, Label } from "semantic-ui-react";

const BetaAnnouncementMessage = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const isDismissed = localStorage.getItem('betaMessageDismissed');
    if (isDismissed === 'true') {
      setVisible(false);
    }
  }, []);

  const onDismiss = () => {
    setVisible(false);
    localStorage.setItem('betaMessageDismissed', 'true');
  };

  if (!visible) return null;

  return (
    <Message
      info
      icon
      onDismiss={onDismiss}
      style={{ 
        marginTop: "1em",
        marginBottom: "1em"
      }}
    >
      <Icon name="rocket" />
      <Message.Content>
        <Message.Header>
          New Beta Version Available!
          <Label color="yellow" size="tiny" style={{ marginLeft: "0.5em" }}>
            NEW
          </Label>
        </Message.Header>
        <p style={{ marginTop: "0.5em", marginBottom: "1em" }}>
          Experience the newly redesigned ArtCollection.io with improved performance and features.
        </p>
        <Button 
          as="a"
          primary 
          size="small"
          href="https://beta.artcollection.io"
          target="_blank"
        >
          <Icon name="external" />
          Try Beta Version
        </Button>
      </Message.Content>
    </Message>
  );
};

export default BetaAnnouncementMessage;